import { useMatches } from "@tanstack/react-router";

interface PageContainerProps {
  children: React.ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  const matches = useMatches();
  const fullBleed = matches.some(
    m => (m.staticData as { fullBleed?: boolean } | undefined)?.fullBleed === true,
  );

  if (fullBleed) {
    return <div className="h-full">{children}</div>;
  }

  return <div className="h-full px-5 pt-5 pb-6">{children}</div>;
}
